import React from "react";

const AboveCard = () => {
  return (
    <div className="d-flex w-100 flex-column justify-content-center align-items-center text-center">
      <h1
        style={{ fontSize: "40px", lineHeight: 1 }}
        className="text-success mt-2"
      >
        Business Impact Tracker
      </h1>
      <h3 className=" mb-4">Assessing the ESG maturity of your business</h3>
    </div>
  );
};

export default AboveCard;
